import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import set_symmetry_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/set_symmetry_plane.svg';
import { img } from '@phi/components';
import { complete_setting_symmetry_plane, set_symmetry_plane } from '@frontend/scene';
import SetSymmetryTooltip from './SetSymmetryTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const SetSymmetryPlaneIcon = set_symmetry_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Clear/set symmetry';
        },

        disabled() {
            if (this.active)
                return false;
            else return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || this.state.adding_vertex
                || this.state.drawing_edge
                || this.state.carving;
        },

        active() {
            return this.state.setting_symmetry_plane
                || this.state.symmetry_plane_selected;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.setting_symmetry_plane) {
                if (this.state.symmetry_plane_selected)
                    complete_setting_symmetry_plane();
                else
                    this.state.setting_symmetry_plane = false;
            } else if (this.state.symmetry_plane_selected)
                set_symmetry_plane();
            else
                set_symmetry_plane();
        },
    },

    render() {
        return h(BarButton, {
            id: 'set-symmetry-plane-button',
            wrapperId: 'set-symmetry-plane-wrapper',
            onClick: this.onClick,
            active: this.active,
            disabled: this.disabled,
            selected: this.state.tut_stage === 9,
            tippy: 'left',
            help: 'set_symmetry_plane',
        }, {
            label: () => 'Symmetry',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(set_symmetry_svg, this.alt),
            tooltip: SetSymmetryTooltip,
        });
    },
});
